import React, { useState, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';

import useOutsideClick from '#/hooks/useClickOutside';
import refreshIcon from '#/assets/icons/refresh.svg';
import smallArrowIcon from '#/assets/icons/small-arrow.svg';
import checkIcon from '#/assets/icons/check.svg';
import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


function Dropdown({ itens, onSelect, active }) {
  const [isOpen, setOpen] = useState(false);
  const listRef = useRef(null);
  const buttonRef = useRef(null);
  const { t } = useTranslation();

  useOutsideClick(listRef, buttonRef, toggle, isOpen);

  function toggle() {
    setOpen(!isOpen);
  }

  return (
    <div className={styles.wrapper}>
      <button
        ref={buttonRef}
        onClick={toggle}
        className={[isOpen && styles.isOpen, styles.button].join(' ')}
      >
        {active ? <span className={styles.active} /> : null}
        <img
          src={refreshIcon}
          alt={t('UPDATE_ICON')}
          className={styles.refresh}
        />
        <img
          src={smallArrowIcon}
          alt={t('ARROW_MENU')}
          className={styles.arrow}
        />
      </button>
      <TransitionGroup>
        {isOpen && (
          <CSSTransition
            unmountOnExit={true}
            in={isOpen}
            timeout={120}
            classNames={{
              enter: styles['move-enter'],
              enterActive: styles['move-enter-active'],
            }}
          >
            <ul className={styles.listWrapper} ref={listRef}>
              <p className={styles.text}>{t('UPDATE_AUTOMATICALLY')}</p>
              {itens.map(item => {
                return (
                  <li
                    key={item.id}
                    className={styles.listItem}
                    onClick={() => {
                      toggle();
                      onSelect(item.value);
                    }}
                  >
                    <strong className={styles.name}>{item.name}</strong>
                    {active === item.value && (
                      <img
                        src={checkIcon}
                        alt={t('ITEM_ALREADY_ACTIVE')}
                        className={styles.image}
                      />
                    )}
                  </li>
                );
              })}
            </ul>
          </CSSTransition>
        )}
      </TransitionGroup>
    </div>
  );
}

Dropdown.propTypes = {
  itens: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  active: PropTypes.number.isRequired,
};

export default Dropdown;
